import { useTranslation } from "react-i18next";
import { SkeletonBlock } from "./primitives";

export const PageSkeleton = ({ lines = 5 }: { lines?: number }) => {
  const { t } = useTranslation("common");

  return (
    <main className="app-page">
      <div className="app-container" role="status" aria-busy="true" aria-label={t("common.states.loading")}>
        <div className="mb-8 max-w-3xl space-y-4">
          <SkeletonBlock className="h-5 w-28" />
          <SkeletonBlock className="h-14 w-full max-w-xl" />
          <SkeletonBlock className="h-5 w-full max-w-md" />
        </div>
        <div className="grid gap-4 md:grid-cols-[1.2fr_0.8fr]">
          <div className="app-surface space-y-4 p-5 sm:p-6">
            {Array.from({ length: lines }).map((_, index) => (
              <div key={index} className="grid gap-3 sm:grid-cols-[1fr_9rem] sm:items-center">
                <div className="space-y-2">
                  <SkeletonBlock className="h-4 w-3/4" />
                  <SkeletonBlock className="h-3 w-1/2" />
                </div>
                <SkeletonBlock className="h-9 w-full" />
              </div>
            ))}
          </div>
          <div className="app-surface p-5 sm:p-6">
            <SkeletonBlock className="h-48 w-full" />
            <div className="mt-5 grid grid-cols-2 gap-3">
              <SkeletonBlock className="h-16" />
              <SkeletonBlock className="h-16" />
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};
